import authAxios from '@services/authAxios';

const postCancelSellout = async (id) => {
    const { data } = await authAxios({
        method: 'POST',
        url: `/api/v1/cancel-process/sellout-date`,
        data: { id },
    });

    return data;
};

export default postCancelSellout;
